export default "__VITE_ASSET__1pYcgiCp__"